import { ActivityLog } from './activityLog';

export interface JobHistoryItem {
  id: string;
  name?: string;
  description?: string;
  positionName?: string;
  headcount?: number;
  minimumSalary?: string;
  maximumSalary?: string;
  currencySymbol?: string;
  requirements?: string;
  isDefault?: boolean;
  template?: any;
  jobType?: any;
  location?: any;
  department?: any;
  createdAt?: string;
  updatedAt?: string;
  createdBy?: string;
  updatedBy?: string;
}

export interface JobHistoryResponse {
  message: string;
  data: {
    result: JobHistoryItem[];
    total: number;
  };
  statusCode: number;
}

export enum JobHistoryAction {
  CREATE = 'CREATE',
  UPDATE = 'UPDATE',
  DELETE = 'DELETE',
  STATUS_CHANGE = 'STATUS_CHANGE',
  APPROVE = 'APPROVE',
  REJECT = 'REJECT',
}

export const JobHistoryActionLabels = {
  [JobHistoryAction.CREATE]: 'Tạo mới',
  [JobHistoryAction.UPDATE]: 'Cập nhật',
  [JobHistoryAction.DELETE]: 'Xóa',
  [JobHistoryAction.STATUS_CHANGE]: 'Thay đổi trạng thái',
  [JobHistoryAction.APPROVE]: 'Phê duyệt',
  [JobHistoryAction.REJECT]: 'Từ chối',
};

export const JobFieldLabels = {
  positionName: 'Tên vị trí',
  department: 'Phòng ban',
  location: 'Địa điểm',
  headcount: 'Số lượng tuyển',
  minimumSalary: 'Lương tối thiểu',
  maximumSalary: 'Lương tối đa',
  jobType: 'Loại công việc',
  status: 'Trạng thái',
  openDate: 'Ngày mở',
  closeDate: 'Ngày đóng',
  requirements: 'Yêu cầu công việc',
  createdReason: 'Lý do tạo',
};
